import React from "react";
import { TabId } from "../hooks/useTabManager";

export const a11yTabProps = (id: TabId) => ({
  id: `tab-${id}`,
  "aria-controls": `tabpanel-${id}`,
});
export type TabContentProps = {
  id: TabId;
  activeId: TabId;
};
export const TabContent: React.FC<TabContentProps> = ({
  children,
  activeId,
  id,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={activeId !== id}
      id={`tabpanel-${id}`}
      aria-labelledby={`tab-${id}`}
      style={{
        display: activeId === id ? "block" : "none",
      }}
      {...other}
    >
      {children}
    </div>
  );
};
